import { api } from "../../../services/api";
import { common } from "../../../services/apiVariables";
import { Toast } from "../../../services/toast";
import { COUNTRY_ACTIONS, CREATE_ADSKEY_EXISTS_ACTIONS, CURRENCY_ACTIONS, DATA_UPLOAD_STATUS_ACTIONS, GET_ADSKEY_EXISTS_ACTIONS, GET_TRENDING_BONDS_ACTIONS, INDUSTRY_ACTIONS, ISSUE_TYPE_ACTIONS, MATURITY_YEAR_ACTIONS, REGION_ACTIONS, SECTOR_ACTIONS, SEND_FEEDBACK_ACTIONS, SUPPORT_FORM_ACTIONS } from "../../actionType/common";

export const getCountry =
    () => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: COUNTRY_ACTIONS.COUNTRY_BONDS_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.countries })
                .then((data: any) => {


                    dispatch({
                        type: COUNTRY_ACTIONS.COUNTRY_BONDS,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: COUNTRY_ACTIONS.COUNTRY_BONDS_ERROR,
                        payload: [],
                    });
                    reject(error);
                });
        });
    };
export const getTrendingBonds =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: GET_TRENDING_BONDS_ACTIONS.GET_TRENDING_BONDS_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.trendingBonds, body })
                .then((data: any) => {
                    dispatch({
                        type: GET_TRENDING_BONDS_ACTIONS.GET_TRENDING_BONDS,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: GET_TRENDING_BONDS_ACTIONS.GET_TRENDING_BONDS_ERROR,
                        payload: [],
                    });
                    reject(error);
                });
        });
    };
export const getIssueType =
    (body?: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: ISSUE_TYPE_ACTIONS.ISSUE_TYPE_BONDS_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.issueType, body })
                .then((data: any) => {
                    //console.log("ISSUE type ", data);

                    dispatch({
                        type: ISSUE_TYPE_ACTIONS.ISSUE_TYPE_BONDS,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: ISSUE_TYPE_ACTIONS.ISSUE_TYPE_BONDS_ERROR,
                        payload: [],
                    });
                    reject(error);
                });
        });
    };

export const getCurrency =
    (body?: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: CURRENCY_ACTIONS.CURRENCY_BONDS_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.currency, body })
                .then((data: any) => {
                    dispatch({
                        type: CURRENCY_ACTIONS.CURRENCY_BONDS,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: CURRENCY_ACTIONS.CURRENCY_BONDS_ERROR,
                        payload: [],
                    });
                    reject(error);
                });
        });
    };

export const getSector =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: SECTOR_ACTIONS.SECTOR_BONDS_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.sectors, body })
                .then((data: any) => {
                    dispatch({
                        type: SECTOR_ACTIONS.SECTOR_BONDS,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: SECTOR_ACTIONS.SECTOR_BONDS_ERROR,
                        payload: [],
                    });
                    reject(error);
                });
        });
    };

export const getIndustry =
    (body?: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: INDUSTRY_ACTIONS.INDUSTRY_BONDS_REQUEST,
            payload: { isBondIndustryLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.industry, body })
                .then((data: any) => {
                    dispatch({
                        type: INDUSTRY_ACTIONS.INDUSTRY_BONDS,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: INDUSTRY_ACTIONS.INDUSTRY_BONDS_ERROR,
                        payload: [],
                    });
                    reject(error);
                });
        });
    };

export const getRegion =
    (body?: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: REGION_ACTIONS.REGION_BONDS_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.regions, body })
                .then((data: any) => {
                    dispatch({
                        type: REGION_ACTIONS.REGION_BONDS,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: REGION_ACTIONS.REGION_BONDS_ERROR,
                        payload: [],
                    });
                    reject(error);
                });
        });
    };
export const getMaturityYears =
    (body?: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: MATURITY_YEAR_ACTIONS.MATURITY_YEAR_BONDS_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.MaturityYears, body })
                .then((data: any) => {
                    dispatch({
                        type: MATURITY_YEAR_ACTIONS.MATURITY_YEAR_BONDS,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: MATURITY_YEAR_ACTIONS.MATURITY_YEAR_BONDS_ERROR,
                        payload: [],
                    });
                    reject(error);
                });
        });
    };

export const sendFeedback =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: SEND_FEEDBACK_ACTIONS.SEND_FEEDBACK_REQUEST,
            payload: { isPostCreateLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.sendFeedBack, body })
                .then((data: any) => {
                    dispatch({ type: SEND_FEEDBACK_ACTIONS.SEND_FEEDBACK_RESPONSE, payload: data });
                    resolve(data);
                    // if (data?.code === 200) {
                    //     Toast({ type: 'success', message: data.message, title: data.status });
                    // }
                })
                .catch((error) => {
                    Toast({ type: 'danger', message: error.message, title: error.status });
                    dispatch({ type: SEND_FEEDBACK_ACTIONS.SEND_FEEDBACK_ERROR, payload: [] });
                    reject(error);
                });
        });
    };

export const supportForm =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: SUPPORT_FORM_ACTIONS.SUPPORT_FORM_REQUEST,
            payload: { isUsersDetailEditLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.support, body, isFormData: true })
                .then((data: any) => {
                    // Toast({ type: 'success', message: '', title: 'success' });
                    dispatch({ type: SUPPORT_FORM_ACTIONS.SUPPORT_FORM_RESPONSE, payload: data });
                    resolve(data);
                })
                .catch((error) => {
                    Toast({ type: 'danger', message: error.message, title: error.status });
                    dispatch({ type: SUPPORT_FORM_ACTIONS.SUPPORT_FORM_ERROR, payload: [] });
                    reject(error);
                });
        });
    };

export const getDataUploadStatus =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: DATA_UPLOAD_STATUS_ACTIONS.DATA_UPLOAD_STATUS_REQUEST,
            payload: { isDataUploadStatusLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.getUploadStatus, body, })
                .then((data: any) => {
                    dispatch({ type: DATA_UPLOAD_STATUS_ACTIONS.DATA_UPLOAD_STATUS_RESPONSE, payload: data });
                    resolve(data);
                })
                .catch((error) => {
                    Toast({ type: 'danger', message: error.message, title: error.status });
                    dispatch({ type: DATA_UPLOAD_STATUS_ACTIONS.DATA_UPLOAD_STATUS_ERROR, payload: [] });
                    reject(error);
                });
        });
    };

export const getAdsKeyExists =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: GET_ADSKEY_EXISTS_ACTIONS.GET_ADSKEY_EXISTS_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.getAdsKeyExists, body })
                .then((data: any) => {
                    dispatch({
                        type: GET_ADSKEY_EXISTS_ACTIONS.GET_ADSKEY_EXISTS_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: GET_ADSKEY_EXISTS_ACTIONS.GET_ADSKEY_EXISTS_ERROR,
                        payload: [],
                    });
                    reject(error);
                });
        });
    };
export const createAdsKeyExists =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: CREATE_ADSKEY_EXISTS_ACTIONS.CREATE_EXISTS_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...common.createAdsKeyExists, body })
                .then((data: any) => {
                    dispatch({
                        type: CREATE_ADSKEY_EXISTS_ACTIONS.CREATE_EXISTS_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: CREATE_ADSKEY_EXISTS_ACTIONS.CREATE_EXISTS_ERROR,
                        payload: [],
                    });
                    reject(error);
                });
        });
    };

